import { Box } from "@radix-ui/themes";

const Discord = () => {
  return (
    <Box
      style={{
        display: "inline-block",
        position: "fixed",
        left: "5px",
        top: "5px",
        padding: "5px",
        fontSize: "10px",
        zIndex: 1000,
        backgroundColor: "black",
      }}
    >
      RoR Discord:
      <br />
      <a href={"https://discord.gg/JB9hsnsFqY"}>
        https://discord.gg/JB9hsnsFqY
      </a>
    </Box>
  );
};

export { Discord };
